import { CONSULT_LEGAL_ID, CONSULT_LEGAL_ID_ERROR } from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const consultLegalIdAction = (params) => async (dispatch) => {
  const { incode_id } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.post(
      `/api/companies/${incode_id}/linked-up/orders/download-receipt`,
    );

    const { data, status } = response || {};

    dispatch({
      method: 'post',
      payload: data || {},
      status: status || {},
      type: CONSULT_LEGAL_ID,
    });
  } catch (e) {
    dispatch({
      method: 'post',
      payload: e || {},
      type: CONSULT_LEGAL_ID_ERROR,
    });
  }
};
